import React from "react";
import { Holiday } from "../types/Holiday";
import { Button, Table } from "react-bootstrap";
import "../styles/EmployeeList.css";
import { Edit, Trash } from "lucide-react";
import { useSelector } from "react-redux";
import { StoreState } from "../redux/reducers";
import { AuthUserType } from "../redux/actions/authUserActions";

interface Props {
  holidays: Holiday[];
  onEdit: (holiday: Holiday) => void;
  onDelete: (id: number) => void;
}

const HolidayList: React.FC<Props> = ({ holidays, onEdit, onDelete }) => {
  const authUser = useSelector<StoreState, AuthUserType>(
    (state) => state.authUser,
  );

  return (
    <Table className="custom-employee-table" responsive>
      <thead>
        <tr>
          <th>S.No</th>
          <th>Day</th>
          <th>Month</th>
          <th>Year</th>
          <th>Reason</th>
          {authUser?.role === "Admin" && <th>Action</th>}
        </tr>
      </thead>
      <tbody>
        {[...holidays].sort((a,b)=>b.id-a.id).map((h, index) => (
          <tr key={h.id}>
            <td>{index + 1}</td>
            <td>{h.day}</td>
            <td>{h.month}</td>
            <td>{h.year}</td>
            <td>{h.reason}</td>
            {authUser?.role === "Admin" && (
              <td>
                <Button
                  variant="success"
                  onClick={() => {
                    onEdit(h);
                  }}
                  style={{
                    padding: "5px",
                    borderRadius: "5px",
                  }}
                  className="mr-2"
                >
                  <Edit />
                </Button>
                <Button
                  variant="danger"
                  onClick={() => onDelete(h.id)}
                  style={{
                    padding: "5px",
                    borderRadius: "5px",
                  }}
                >
                  <Trash />
                </Button>
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default HolidayList;
